import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bce68ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "layout__body clearfix" }
const _hoisted_3 = { class: "body__right" }
const _hoisted_4 = { class: "right__header" }
const _hoisted_5 = { class: "right__main" }

import AppMain from '@/views/layout/AppMain/index.vue'
import Header from '@/views/layout/Header/index.vue'
import AsideBar from '@/views/layout/AsideBar/index.vue'
import TagsView from '@/views/layout/TagsView/index.vue'
import { useCommon } from '@/store/useCommon'
import { useDocumentDownloadList } from '@/utils/cacheData'
import { usePageConfig } from '@/utils/useComponentConfig'
import { computed, reactive, watch} from 'vue'
// import { downloadFile } from '@/utils/tools'
// import { getDocumentDownloadApi } from '@/api/operating'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const storeCommon = useCommon()

// 菜单是否折叠
const isCollapse = computed(() => storeCommon.isCollapse)

const dialogConfig = reactive({
  visible: false,
  action: 'movie',
  config: {
    title: '文档下载',
    isShowConfirm: false,
  },

  confirm: () => {
  }
})

const tableConfig: TableConfigType = reactive({
  data: [],
  isCardBlock: false,
  paginationConfig: usePageConfig() as any,
  isShowHeader: false,
  config: {
    loading: false,
  },
})

const columnConfig = reactive({
  columnList: [
    {
      label: '序号',
      prop: 'no',
      width: 100
    },
    { label: '文档名称', prop: 'name' },
    {
      label: '操作',
      prop: '',
      widgetType: 'buttons',
      width: 100,
      buttonsList: [
        {
          label: '下载',
          func: (row: any) => {
            // 下载模板文件
            const { url, name } = row
            // downloadFile(url, name, '_self')
          }
        }
      ]
    }
  ]
})

const getDocumentDownload = async () => {
  // const res = await useDocumentDownloadList() as ResType
  // const res = await getDocumentDownloadApi() as ResType
  // if (res.code === '0') {
  //   tableConfig.data = res.data.map((item, index) => {
  //     return {
  //       ...item,
  //       no: index + 1,
  //     }
  //   })
  // }
}


(window as any)?.microApp?.addDataListener((data: any) => {
  if (data.action === 'handleDownload') {
    dialogConfig.visible = true
  }
}, true)

watch(() => dialogConfig.visible, (val) => {
  if (val) {
    // getDocumentDownload()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_column = _resolveComponent("column")!
  const _component_common_table = _resolveComponent("common-table")!
  const _component_MDialog = _resolveComponent("MDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "body__left",
          style: _normalizeStyle({ 'minWidth': isCollapse.value ? '' : '260px' })
        }, [
          _createVNode(AsideBar)
        ], 4),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(TagsView)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(AppMain)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_MDialog, {
      modelValue: dialogConfig.visible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogConfig.visible) = $event)),
      dialogConfig: dialogConfig.config,
      onOnConfirm: dialogConfig.confirm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_common_table, {
          showPagination: false,
          ref: "tableRef",
          style: {"width":"100%"},
          "table-config": tableConfig,
          "pagination-config": tableConfig.paginationConfig,
          options: tableConfig.config
        }, {
          default: _withCtx(() => [
            _createVNode(_component_column, {
              "column-list": columnConfig.columnList
            }, null, 8, ["column-list"])
          ]),
          _: 1
        }, 8, ["table-config", "pagination-config", "options"])
      ]),
      _: 1
    }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])
  ], 64))
}
}

})